import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kui-geoname-value',
  templateUrl: './geoname-value.component.html',
  styleUrls: ['./geoname-value.component.scss']
})
export class GeonameValueComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
